// extracted by mini-css-extract-plugin
module.exports = {"calculatorPage":"CalculatorPage_calculatorPage__kpkf3"};